import type { ReactNode } from 'react';

import { ADMIN_AUTH_STYLES } from './admin-auth-styles';

/**
 * Palco cinematográfico do login admin: injeta o CSS escopado (`.admin-auth`) e
 * renderiza o fundo full-bleed (aurora animada + grid + granulado) atrás do
 * `children` (o card). 100% self-contained, sem tokens globais.
 */
export function AdminAuthStage({ children }: { children: ReactNode }) {
  return (
    <div className="admin-auth">
      <style dangerouslySetInnerHTML={{ __html: ADMIN_AUTH_STYLES }} />
      <div className="bgfx" aria-hidden>
        <div className="blob b1" />
        <div className="blob b2" />
        <div className="blob b3" />
      </div>
      <div className="grid-overlay" aria-hidden />
      <div className="grain" aria-hidden />
      <div className="stage">{children}</div>
    </div>
  );
}
